module.exports = __webpack_public_path__ + "img/icon_hydraulic_risk_reduction_level.a31b5750.svg";